export enum Permissions {
  EDIT_USERS_ROLE = 'edit-users-role',
  CREATE_ASSET = 'create-asset',
  MINT_ASSET = 'mint',
  BURN_ASSET = 'burn',
  CLAWBACK_ASSET = 'clawback',
  FREEZE_ACCOUNT = 'update-auth-flags',
  DISTRIBUTE_ASSET = 'transfer',
  AUTHORIZE_ASSET = 'authorize',
  MOVE_BALANCES_VAULTS = 'move-balances-vaults',
  MOVE_BALANCES_EXTERNAL_ACCOUNTS = 'move-balances-external-accounts',
  CREATE_CERTIFICATES = 'create-certificates',
  CREATE_WALLET = 'create-wallet',
  INVEST_CERTIFICATE = 'invest-certificate',
}
